import { Button, EButtonColorVariant, ETagVariant, Tag } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

import { PHOTOS, RV_CAMPSITE_BUNDLES_LANDING_PAGE } from '@/constants/urls';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { useRouter } from '@/hooks/useRouter';

type TActionBarProps = {
  photoCount: number;
};

export const ActionBar = ({ photoCount }: TActionBarProps) => {
  const { isMobile } = useBreakpoint();
  const intl = useIntl();

  const { query } = useRouter();
  const { slug, ...restParams } = query;
  const params = new URLSearchParams(restParams as Record<string, string>).toString();

  return isMobile ? (
    <div className="absolute bottom-0 w-full px-4 mb-4 text-end">
      <Tag
        label={intl.formatMessage(
          { defaultMessage: '1 of {photoCount}', id: 'W2HUSG' },
          { photoCount },
        )}
        variant={ETagVariant.Dark}
      />
    </div>
  ) : (
    <Button
      className="absolute right-4 bottom-4"
      onDark
      variant={EButtonColorVariant.Tertiary}
      href={`${RV_CAMPSITE_BUNDLES_LANDING_PAGE}/${slug}${PHOTOS}?${params}`}
      label={intl.formatMessage(
        {
          defaultMessage: 'View {photoCount, plural, one {# photo} other {# photos}}',
          id: '7bdc8w',
        },
        { photoCount },
      )}
    />
  );
};
